/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Intensity_StrongInputs */

const en_us2_profile_editors_pain_intensity_strong = /** @type {(inputs: Profile_Editors_Pain_Intensity_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`strong`)
};

const pt_br2_profile_editors_pain_intensity_strong = /** @type {(inputs: Profile_Editors_Pain_Intensity_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forte`)
};

const es_419_profile_editors_pain_intensity_strong = /** @type {(inputs: Profile_Editors_Pain_Intensity_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fuerte`)
};

const pt_pt2_profile_editors_pain_intensity_strong = /** @type {(inputs: Profile_Editors_Pain_Intensity_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forte`)
};

const fr_fr2_profile_editors_pain_intensity_strong = /** @type {(inputs: Profile_Editors_Pain_Intensity_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forte`)
};

const de_de2_profile_editors_pain_intensity_strong = /** @type {(inputs: Profile_Editors_Pain_Intensity_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`stark`)
};

const it_it2_profile_editors_pain_intensity_strong = /** @type {(inputs: Profile_Editors_Pain_Intensity_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`forte`)
};

/**
* | output |
* | --- |
* | "strong" |
*
* @param {Profile_Editors_Pain_Intensity_StrongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_intensity_strong = /** @type {((inputs?: Profile_Editors_Pain_Intensity_StrongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Intensity_StrongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_intensity_strong(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_intensity_strong(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_intensity_strong(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_intensity_strong(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_intensity_strong(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_intensity_strong(inputs)
	return en_us2_profile_editors_pain_intensity_strong(inputs)
});
export { profile_editors_pain_intensity_strong as "profile-editors.pain_intensity_strong" }